import { render, staticRenderFns } from "./NoteHeader.vue?vue&type=template&id=5fe8ceae&scoped=true&"
import script from "./NoteHeader.vue?vue&type=script&lang=js&"
export * from "./NoteHeader.vue?vue&type=script&lang=js&"
import style0 from "./NoteHeader.vue?vue&type=style&index=0&id=5fe8ceae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe8ceae",
  null
  
)

export default component.exports